<div class="bar d-flex mt-5px">
    <div *ngFor="let i of barItems" class="bar-item d-inline-block">
        <span class="bar-item-value critical" [style.width.%]="getBarItemValue(i)"></span>
        <span  class="bar-axis-label">{{i}}</span>
        <span *ngIf="i === barItems.length - 1" class="bar-axis-label pull-right">{{i+1}}</span>
    </div>
</div>
